// import React, { useState } from "react";
// import { X } from "lucide-react";
// import { useDispatch, useSelector } from "react-redux";
// import { updatePassword } from "../../redux/actions/authActions";
// import { FullScreenLoader } from "../Components/Loader";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// const UpdatePasswordModal = ({ isOpen, onClose }) => {
//   const dispatch = useDispatch();
//   const { userInfo } = useSelector((state) => state.auth);
//   const dashboardData = useSelector((state) => state.dashboard.data);
//   const { loading } = useSelector((state) => state.auth || {});
  
//   // Use dashboard data if available, otherwise fall back to userInfo
//   const userDetails = dashboardData || userInfo;
  
//   const [formData, setFormData] = useState({
//     new_password: "",
//     confirm_password: "",
//   });
//   const [errors, setErrors] = useState({});
// const [showPasswords, setShowPasswords] = useState({
//     new_password: false,
//     confirm_password: false,
//   });

//   const togglePasswordVisibility = (field) => {
//     setShowPasswords((prev) => ({
//       ...prev,
//       [field]: !prev[field],
//     }));
//   };
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.new_password) {
//       newErrors.new_password = "New password is required";
//     } else if (formData.new_password.length < 6) {
//       newErrors.new_password = "Password must be at least 6 characters";
//     }

//     if (!formData.confirm_password) {
//       newErrors.confirm_password = "Please confirm your password";
//     } else if (formData.new_password !== formData.confirm_password) {
//       newErrors.confirm_password = "Passwords do not match";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     // Get user ID - check both dashboardData and userInfo
//     // For customer (role 4), use customer_id; for others, use user_id
//     const roleId = userDetails?.role_id || userInfo?.role_id;
//     let userId = null;
    
//     if (roleId === "4" || roleId === 4) {
//       // Customer role - use customer_id
//       userId = userDetails?.customer_id || userInfo?.customer_id;
//     } else {
//       // Salesman, Dealer, Admin - use user_id
//       userId = userDetails?.user_id || userInfo?.user_id;
//     }

//     if (!userId) {
//       console.error("User ID not found. userDetails:", userDetails, "userInfo:", userInfo);
//       alert("User ID not found. Please try logging in again.");
//       return;
//     }

//     const passwordData = {
//       id: userId,
//       new_password: formData.new_password,
//     };

//     const result = await dispatch(updatePassword(passwordData, userInfo.access_token));

//     if (result?.success) {
//       // Reset form and close modal
//       setFormData({
//         new_password: "",
//         confirm_password: "",
//       });
//       setErrors({});
//       onClose();
//     } else {
//       // Error is already handled by the action (toast notification)
//       // Just log for debugging
//       console.error("Password update failed:", result?.error);
//     }
//   };

//   const handleClose = () => {
//     setFormData({
//       new_password: "",
//       confirm_password: "",
//     });
//     setErrors({});
//     onClose();
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       <FullScreenLoader 
//         show={loading} 
//         message="Updating password..." 
//         variant="primary"
//         blurIntensity="md"
//       />
      
//       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//         <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
//           {/* Header */}
//           <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200">
//             <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
//               Update Password
//             </h2>
//             <button
//               onClick={handleClose}
//               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//               aria-label="Close"
//             >
//               <X size={24} className="text-gray-600" />
//             </button>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="p-4 sm:p-6">
//             <div className="space-y-4">
//               {/* New Password */}
//               <div>
//                 <label
//                   htmlFor="new_password"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   New Password
//                 </label>
//                 <input
//                   type="password"
//                   id="new_password"
//                   name="new_password"
//                   value={formData.new_password}
//                   onChange={handleChange}
//                   className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 ${
//                     errors.new_password ? "border-red-500" : "border-gray-300"
//                   }`}
//                   placeholder="Enter new password"
//                 />
//                 {errors.new_password && (
//                   <p className="mt-1 text-sm text-red-600">{errors.new_password}</p>
//                 )}
//               </div>

//               {/* Confirm Password */}
//               <div>
//                 <label
//                   htmlFor="confirm_password"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Confirm Password
//                 </label>
//                 <input
//                   type="password"
//                   id="confirm_password"
//                   name="confirm_password"
//                   value={formData.confirm_password}
//                   onChange={handleChange}
//                   className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 ${
//                     errors.confirm_password ? "border-red-500" : "border-gray-300"
//                   }`}
//                   placeholder="Confirm new password"
//                 />
//                 {errors.confirm_password && (
//                   <p className="mt-1 text-sm text-red-600">{errors.confirm_password}</p>
//                 )}
//               </div>
//             </div>

//             {/* Buttons */}
//             <div className="flex gap-3 mt-6">
//               <button
//                 type="button"
//                 onClick={handleClose}
//                 className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 Update Password
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UpdatePasswordModal;

import React, { useState } from "react";
import { X } from "lucide-react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../redux/actions/authActions";
import { FullScreenLoader } from "../Components/Loader";

const UpdatePasswordModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const dashboardData = useSelector((state) => state.dashboard.data);
  const { loading } = useSelector((state) => state.auth || {});

  const userDetails = dashboardData || userInfo;

  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState({});
  const [showPasswords, setShowPasswords] = useState({
    new_password: false,
    confirm_password: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.new_password) {
      newErrors.new_password = "New password is required";
    } else if (formData.new_password.length < 6) {
      newErrors.new_password = "Password must be at least 6 characters";
    }

    if (!formData.confirm_password) {
      newErrors.confirm_password = "Please confirm your password";
    } else if (formData.new_password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const roleId = userDetails?.role_id || userInfo?.role_id;
    let userId = null;

    if (roleId === "4" || roleId === 4) {
      userId = userDetails?.customer_id || userInfo?.customer_id;
    } else {
      userId = userDetails?.user_id || userInfo?.user_id;
    }

    if (!userId) {
      console.error("User ID not found");
      alert("User ID not found. Please try logging in again.");
      return;
    }

    const passwordData = {
      id: userId,
      new_password: formData.new_password,
    };

    const result = await dispatch(updatePassword(passwordData, userInfo.access_token));

    if (result?.success) {
      setFormData({
        new_password: "",
        confirm_password: "",
      });
      setErrors({});
      setShowPasswords({
        new_password: false,
        confirm_password: false,
      });
      onClose();
    } else {
      console.error("Password update failed:", result?.error);
    }
  };

  const handleClose = () => {
    setFormData({
      new_password: "",
      confirm_password: "",
    });
    setErrors({});
    setShowPasswords({
      new_password: false,
      confirm_password: false,
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <FullScreenLoader
        show={loading}
        message="Updating password..."
        variant="primary"
        blurIntensity="md"
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
          <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
              Update Password
            </h2>
            <button
              onClick={handleClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Close"
            >
              <X size={24} className="text-gray-600" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-4 sm:p-6">
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="new_password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  New Password
                </label>
                <div className="relative">
                  <input
                    type={showPasswords.new_password ? "text" : "password"}
                    id="new_password"
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 pr-10 ${
                      errors.new_password ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter new password"
                  />
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("new_password")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none transition-colors"
                    aria-label={showPasswords.new_password ? "Hide password" : "Show password"}
                  >
                    {showPasswords.new_password ? (
                      <FaEyeSlash size={16} />
                    ) : (
                      <FaEye size={16} />
                    )}
                  </button>
                </div>
                {errors.new_password && (
                  <p className="mt-1 text-sm text-red-600">{errors.new_password}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="confirm_password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    type={showPasswords.confirm_password ? "text" : "password"}
                    id="confirm_password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 pr-10 ${
                      errors.confirm_password ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Confirm new password"
                  />
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("confirm_password")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none transition-colors"
                    aria-label={showPasswords.confirm_password ? "Hide password" : "Show password"}
                  >
                    {showPasswords.confirm_password ? (
                      <FaEyeSlash size={16} />
                    ) : (
                      <FaEye size={16} />
                    )}
                  </button>
                </div>
                {errors.confirm_password && (
                  <p className="mt-1 text-sm text-red-600">{errors.confirm_password}</p>
                )}
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                type="button"
                onClick={handleClose}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="flex-1 px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Update Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdatePasswordModal;